import { LS_LAST_MESSAGE_SENT_AT } from '../../common/constants/private';

export const getLastMessageSentAt = (): number | null => {
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	const lastMessageSentAt = localStorage.getItem(LS_LAST_MESSAGE_SENT_AT);

	if (!lastMessageSentAt) {
		return null;
	}

	const timestamp = parseInt(lastMessageSentAt);

	if (isNaN(timestamp)) {
		return null;
	}

	return timestamp;
};
